var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"text-lg-h6"},[_vm._v("Administracion de usuarios")]),_c('crudusuario')],1)}
var staticRenderFns = []

export { render, staticRenderFns }